import { ApiNetworkError } from "@/errors/api/api-network-error";

/**
 * APIタイムアウトエラー
 */
export class ApiTimeoutError extends ApiNetworkError {
  /**
   * コンストラクタ
   */
  constructor(message: string) {
    super(message);
  }
}
